import { FC } from 'react';
import { useSelector } from 'react-redux';

import type { Store } from 'app-redux/types/storeTypes';
import { ViewerDevice } from 'constants/enums';

import MobileHeader from './MobileHeader';
import DesktopHeader from './DesktopHeader';

import type { IHeader } from '../config/declarations';

const Header: FC<IHeader> = ({ header }) => {
  const isMobileViewWidth = useSelector((store: Store) => store.server.app.isMobileViewWidth);
  const viewerDevice = useSelector((store: Store) => store.server.app.viewerDevice);
  const isMobileOrTablet = isMobileViewWidth || (viewerDevice === ViewerDevice.TABLET);

  if (!header) {
    return null;
  }

  if (isMobileOrTablet) {
    return <MobileHeader header={header} />;
  }

  return (<DesktopHeader header={header} />);
};

export default Header;
